import { IrisProjectI } from '@iris/common/models';
import { NgSelectEventHandler } from '@iris/common/modules/fields/sk-select-field/ng-select-event-handler.sk';
import { StrakitSelectComponent } from '@ngx-strakit/cdk/controls';

export class DfPropProjectOnAddEventHandler implements NgSelectEventHandler {
  readonly eventType = 'addEvent';

  /** This handler ensures that when multiple selection is enabled, the same project cannot be selected more than once.
   * (as we have two groups Recent Projects and All Projects, the user might end up selecting the same project from both groups)
   * If the user tries to select a project that has already been selected, the handler will automatically unselect the duplicate entry, keeping only one instance of each selected project.
   * @param ngSelect
   */
  handle(ngSelect: StrakitSelectComponent): void {
    if (!ngSelect.multiple || !ngSelect.selectedItems?.length || ngSelect.selectedItems.length === 1) {
      return;
    }

    const lastSelectedItem = ngSelect.selectedItems?.at(-1);
    const isDuplicate = ngSelect.selectedItems.map((i): IrisProjectI => i.value as IrisProjectI)
      .toSpliced( -1, 1)
      .some(i => i.id && i.id === (lastSelectedItem?.value as IrisProjectI)?.id);

    if (isDuplicate) {
      ngSelect.unselect(lastSelectedItem);
    }
  }
}
